module.exports = __webpack_public_path__ + "0111d6ad6dab8a113341c66bdde282d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/background.png
// module id = 28
// module chunks = 0